import React from 'react';
import { Icon } from '@ant-design/react-native';
import { Badge } from '@md-design-system/Badge';
import { useI18n } from '@shared/i18n/useI18n';
import {
    DOCUMENT_STATUS_STYLE,
    DOCUMENTS_ICON,
    DOCUMENTS_STATUS_BADGE_STYLE,
    DOCUMENTS_STATUS_BADGE_TEXT_STYLE,
} from '../../constants';
import type { TDocumentStatusPillProps } from '../../types';

export const DocumentStatusPill = ({ status, doctorGender }: TDocumentStatusPillProps) => {
    const { t } = useI18n();
    const { icon, variant, iconColor } = DOCUMENT_STATUS_STYLE[status];

    return (
        <Badge variant={variant} style={DOCUMENTS_STATUS_BADGE_STYLE} textStyle={DOCUMENTS_STATUS_BADGE_TEXT_STYLE}>
            <Icon name={icon} size={DOCUMENTS_ICON.statusSize} color={iconColor} />
            {'  '}
            {t(`documents.status.${status}.${doctorGender}`)}
        </Badge>
    );
};
